<template>
    <ion-header translucent class="main-menu-toolbar">
        <ion-icon class="menu-icon" v-if="menuIcon" :icon="menuIcon"></ion-icon>
        <ion-text class="menu-title" v-if="menuTitle">{{ menuTitle }}</ion-text>
        <ion-toolbar class="modal-toolbar" mode="md">
            <ion-buttons slot="end">
                <ion-button @click="dismiss">
                    {{ t("messages.application.close") }} 
                    <ion-icon :src="close" style="font-size: 20px"/>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
    
      <ion-content class="menu-modal-wrapper">
            <div class="main-menu-modal-icon" v-if="menuClass === 'main-menu-modal'">
                <ion-icon :icon="menu" />
            </div>
            <div class="menu-items-wrapper">
                <div class="menu-item" v-for="item in menuItems" :key="item.name" >
                    <div class="sub-menu-chiplet" @click="item.handler">
                        <ion-icon class="chiplet-icon" :icon="item.icon" mode="md" />
                    </div>
                    <div v-if="item.label" class="menu-item-label">{{ item.label }}</div>
                </div>
            </div>

        
      </ion-content>
      
  </template>
  
  <script lang="ts">
  import { computed, defineComponent, ref ,onMounted} from 'vue';
  import { useStore } from "vuex";
  import { IonButton, IonContent, IonHeader, IonToolbar, IonButtons,IonIcon } from '@ionic/vue';
  import { close, menu, musicalNotes , shareSocial } from "ionicons/icons";
  import {ChipletButton} from "@/types/types";
  import translate from "../views/translate";
  
  export default defineComponent({
    name: 'MenuModal',
    components: {
      IonButton,
      IonContent,
      IonHeader,
      IonToolbar,
      IonButtons,
      IonIcon,
    },
    props: {
        dismiss: { type: Function },
        menuItems: { type: Array as () => ChipletButton[] },
        menuClass: { type: String },
        menuTitle: { type: String },
        menuIcon: { type: String },
    },
    setup(props) {
        const store = useStore();
        const localeMessages = computed(() => store.getters.getLocaleMessages());
        const { t } = translate();
        
        

        return {
            close,
            t,
            musicalNotes,
            shareSocial,
            menu
        };
}
  });
  </script>
  
  <style scoped>

    button {
        background: #007bff;
        color: white;
        border: none;
        padding: 8px 12px;
        border-radius: 5px;
        cursor: pointer;
    }

    button:hover {
        background: #0056b3;
    }  

    p {
        text-align: center;
        font-size: 1.2rem;
        margin-top: 2rem;
    }

    .sub-menu-chiplet {
        margin:0px auto 8px auto;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor:pointer;
        width:56px;
        height:56px;
        box-shadow:none;
    }

    .modal-toolbar {
        padding-top: 0;
    }

    .sub-menu-chiplet{
        background-color: var(--color-primary);
    }
    .sub-menu-chiplet ion-icon {
        color: white;
        font-size: 28px;
        text-align: center;
        align-content: center;
        margin-bottom: 2px;
    }

    .menu-items-wrapper {
        width:344px;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        /* justify-content: space-around; */
        /* align-items: center; */
        column-gap: 8px;
        /* margin-top: 20px; */
        row-gap: 20px;
    }

/* Main menu modal items */
.main-menu-modal-icon {
    font-size: 112px;
    width:100%;
    text-align: center;
    margin-top: 0px;
    color:var(--color-primary);
}

ion-content.menu-modal-wrapper {
    --background: white;
}

.main-menu-modal  .menu-item {
    width: 80px;
    display: flex;
    flex-direction: column;
    margin-bottom:auto;
}

.menu-item-label {
    text-align: center;
}

@media only screen and (min-width: 500px) {
    .main-menu-modal > .modal-wrapper  {
        overflow:hidden;
        --width:400px!important;
        --max-height: 600px;
    }
}
    
</style>
  